import React, { Fragment } from "react";

const Layout = (props) => {
  // useEffect(() => {}, [isAuthenticated]);
  return (
    <Fragment>
      <main>{props.children}</main>
    </Fragment>
  );
};

export default Layout;
